'use client';

import { MuiProvider } from '@lfg/ui/providers/MuiProvider';
import React, { PropsWithChildren } from 'react';

import theme from '@/global/styles/theme';

export const NextMuiProvider: React.FC<PropsWithChildren<any>> = ({ children }) => {
  return <MuiProvider theme={theme}>{children}</MuiProvider>;
};
